var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestrictedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-restricted-1377792",
    transform: "translate(481.395 224.983)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6630",
    "data-name": "Rect\\xE1ngulo 6630",
    width: 20,
    height: 20,
    transform: "translate(-481.395 -224.983)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9485",
    "data-name": "Trazado 9485",
    d: "M68.729,65.786v2.371a3.081,3.081,0,0,0-2.879,3.071v4.655a3.081,3.081,0,0,0,3.081,3.081h9.348a3.081,3.081,0,0,0,3.081-3.081V71.228a3.081,3.081,0,0,0-2.879-3.071V65.786a4.866,4.866,0,1,0-9.732,0ZM78.96,71.218v4.655a.681.681,0,0,1-.681.681H68.907a.681.681,0,0,1-.681-.681V71.218a.681.681,0,0,1,.681-.662h9.372A.681.681,0,0,1,78.96,71.218Zm-2.879-5.432v2.371H71.129V65.805a2.467,2.467,0,0,1,4.933,0Z",
    transform: "translate(-545.246 -284.904)",
    fill: "#885067"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictedIcon);
export default __webpack_public_path__ + "static/media/restrictedIcon.8071ac05f515b95746fbaaf0a36bb867.svg";
export { ForwardRef as ReactComponent };